import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import base from "./modules/base";
import client from "./modules/client";
import admin from "./modules/admin";

export default createStore({
  modules: {
    base,
    client,
    admin,
  },
  plugins: [
    createPersistedState({
      paths: ["base", "client", "admin"],
    }),
  ],
});
